import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, useParams, useLocation } from 'react-router-dom';

import { useStore } from 'store';
import { setAgentStaffId, setAgentTableId } from 'store/actions/commons';
import { isLogged } from 'services/commons';
import { setLoginRedirect } from 'util/navigation';
import Loader from 'components/Loader';
import { PROJECT_BASENAME } from 'constants/env';

const HYDRATE_ACTIONS = {
  tableId: setAgentTableId
};

const WAIT_CONTEXT = 100;

const AgentPageRoute = ({
  component: Component,
  strict = false,
  params = [],
  ...props
}) => {
  const [hasHydrated, setHasHydrated] = useState(false);
  const [agentStaffId, dispatch] = useStore(
    (state) => state.commons.agentStaffId
  );
  const { agentId, ...pathParams } = useParams();
  const location = useLocation();
  const isUserLogged = isLogged();

  const showAdminPage = strict ? isUserLogged : isUserLogged || agentStaffId;

  const hydrateStoreForParams = () => {
    params.forEach((param) => {
      const hydrateAction = HYDRATE_ACTIONS[param];
      const value = pathParams[param];
      hydrateAction(value);
    });
  };

  useEffect(() => {
    if (agentId) {
      // TODO: Validate if the agent id is valid with the backend, waiting for this functionality
      dispatch(setAgentStaffId(agentId));

      hydrateStoreForParams();

      setTimeout(() => {
        setHasHydrated(true);
      }, WAIT_CONTEXT);
    }
  }, [agentId]);

  const pathname = location.pathname.replace('/', '')

  // eslint-disable-next-line no-unused-expressions
  !showAdminPage &&
    setLoginRedirect(
      `${pathname}${location.search}`,
      true,
      isUserLogged,
      false
    );

  if (!hasHydrated) return <Loader show />;

  return showAdminPage ? (
    <Component {...props} />
  ) : (
    <Redirect
      to={`/login?redirect=${window.location.origin}${PROJECT_BASENAME}${pathname}${location.search}`}
    />
  );
};

const AgentPageRouteParent = ({ component, ...rest }) => (
  <Route
    {...rest}
    render={() => <AgentPageRoute {...rest} component={component} />}
  />
);

const propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  component: PropTypes.any.isRequired,
  params: PropTypes.arrayOf(PropTypes.string),
  strict: PropTypes.bool
};

AgentPageRoute.propTypes = propTypes;
AgentPageRouteParent.propTypes = propTypes;

export default AgentPageRouteParent;
